import * as z from "zod/v4";
import { V2AdminProductIdSchema } from "./admin-products";

/**
 * Narrow RPC for the admin merchant detail Settings panel. Writes through
 * to the legacy Mongo `self-serve-onboarding-configurations` collection —
 * the same document that the v2 Returns onboarding flow reads
 * `stepsConfig.customCoveragePrice`, `stepsConfig.autoPush`, etc. from.
 *
 * Only the fields the admin UI can edit are exposed here. Everything else
 * in the document is preserved.
 */
export const updateV2OnboardingSettings = {
  name: "updateV2OnboardingSettings" as const,
  input: z.object({
    merchantId: z.string().min(1),
    /**
     * Optional — only used when upserting a brand-new configuration
     * document for a merchant that has no v2 onboarding yet. Ignored on
     * updates to an existing document.
     */
    merchantName: z.string().optional(),
    product: V2AdminProductIdSchema,
    autoPush: z.boolean().optional(),
    /**
     * Coverage price in cents. `null` clears the override.
     */
    customCoveragePrice: z.number().int().nullable().optional(),
    skipBilling: z.boolean().optional(),
    billingRequired: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean(), created: z.boolean() }),
};

export type UpdateV2OnboardingSettingsInput = z.infer<
  typeof updateV2OnboardingSettings.input
>;
